var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3943 2.53718C15.7291 2.20245 16.2718 2.20245 16.6065 2.53718C17.2041 3.13481 19.456 5.5251 21.5653 8.61244C23.6494 11.6629 25.7147 15.5639 25.7147 19.1433C25.7147 22.619 24.6668 25.2845 22.8695 27.0823C21.0758 28.8765 18.6271 29.7147 16.0004 29.7147C13.3737 29.7147 10.925 28.8765 9.1313 27.0823C7.33401 25.2845 6.28613 22.619 6.28613 19.1433C6.28613 15.5639 8.35141 11.6629 10.4355 8.61244C12.5449 5.5251 14.7967 3.13482 15.3943 2.53718ZM16.0004 4.38404C15.0764 5.38167 13.421 7.28155 11.851 9.57952C9.79228 12.5928 8.00042 16.1203 8.00042 19.1433C8.00042 22.2698 8.93528 24.4615 10.3437 25.8703C11.7556 27.2826 13.7354 28.0004 16.0004 28.0004C18.2654 28.0004 20.2453 27.2826 21.6572 25.8703C23.0656 24.4615 24.0004 22.2698 24.0004 19.1433C24.0004 16.1203 22.2086 12.5928 20.1498 9.57951C18.5798 7.28155 16.9244 5.38167 16.0004 4.38404Z",
    fill: "#131542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/Drop.935bf04aba616446ca85244ebef95762.svg";
export { ForwardRef as ReactComponent };